module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'grayscale': _vm.grayscale
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-nav', {
    attrs: {
      "smallScreen": _vm.smallScreen
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.riskData) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "route"
    }
  }, [_c('router-view', {
    attrs: {
      "state": _vm.state,
      "riskData": _vm.riskData,
      "timeBlock": _vm.timeBlock,
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale,
      "setLoading": _vm.setLoading,
      "smallScreen": _vm.smallScreen
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-897c24ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 554
// module chunks = 1